import Embed from './embed';

class BlockquoteEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: value.type === 'author' ? 'authorBlockquote' : 'textualBlockquote',
      customTitle: this.title(value),
      iconName: 'format_quote',
      iconClass: '',
      buttons: ['edit'],
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static title({
    blockquote,
    author,
    role,
    type,
  }) {
    let html = '';
    if (author) html += `${author}`;
    if (role && author) html += ` - ${role}`;
    return `${blockquote} - ${type === 'author' ? html : ''}`;
  }

  static html() {
    return '';
  }

  static value(domNode) {
    return {
      blockquote: domNode.dataset.embedBlockquote,
      author: domNode.dataset.embedAuthor,
      role: domNode.dataset.embedRole,
      type: domNode.dataset.embedType,
      // embedFull se recupera del dataset del elemento
      // donde se almacena como string y no como bool
      full: domNode.dataset.embedFull === 'true',
    };
  }
}

BlockquoteEmbed.blotName = 'blockquoteEmbed';
BlockquoteEmbed.className = 'ql-blockquote';
BlockquoteEmbed.tagName = 'div';

export default BlockquoteEmbed;
